import type { BaseAPIResponse } from '~/types/api';
import { ApiError } from '~/utils/errors';

// Pure API service for relationship operations - no state management
export const relationshipService = {
    async trustCompany(personId: number, companyId: number): Promise<void> {
        const nuxtApp = useNuxtApp();
        
        try {
            const { status, message } = await usePbApi<BaseAPIResponse<null>>(
                nuxtApp.$api.routes.people.companies.trust_company(personId, companyId),
                {
                    method: 'POST',
                }
            );

            if (status !== 201) {
                throw new ApiError(message || 'Failed to trust company', status);
            }
        } catch (error: any) {
            throw ApiError.fromFetchError(error);
        }
    },

    async untrustCompany(personId: number, companyId: number): Promise<void> {
        const nuxtApp = useNuxtApp();
        
        try {
            const { status, message } = await usePbApi<BaseAPIResponse<null>>(
                nuxtApp.$api.routes.people.companies.untrust_company(personId, companyId),
                {
                    method: 'POST',
                }
            );

            if (status !== 201) {
                throw new ApiError(message || 'Failed to untrust company', status);
            }
        } catch (error: any) {
            throw ApiError.fromFetchError(error);
        }
    },

    async getCompanyRelationship(personId: number, companyId: number): Promise<any> {
        const nuxtApp = useNuxtApp();
        
        try {
            const { data, status, message } = await usePbApi<BaseAPIResponse<any>>(
                nuxtApp.$api.routes.people.companies.get_company_relationship(personId, companyId)
            );

            if (status !== 200 || !data) {
                throw new ApiError(message || 'Failed to fetch company relationship', status);
            }

            return data.data;
        } catch (error: any) {
            throw ApiError.fromFetchError(error);
        }
    },

    async scanCompany(personId: number, companyId: number): Promise<void> {
        const nuxtApp = useNuxtApp();
        
        try {
            const { status, message } = await usePbApi<BaseAPIResponse<null>>(
                nuxtApp.$api.routes.people.companies.scan_company(personId, companyId),
                {
                    method: 'POST',
                }
            );

            if (status !== 201) {
                throw new ApiError(message || 'Failed to start manual scan', status);
            }
        } catch (error: any) {
            throw ApiError.fromFetchError(error);
        }
    },
}; 